



















































































import { Component, Vue } from 'vue-property-decorator'
import Alert from '@/components/Shared/Alert.vue';
import GiganautVue from '@/components/Shared/GiganautVue'
import AgenticTaskLogViewer from '@/components/AgenticTasks/AgenticTaskLogViewer.vue';
import ajax from '@/lib/ajax';

interface AgenticTask {
  id: string;
  createdAt: string;
  finishedAt: string | null;
  taskType: number;
  taskCategory: number;
  modelProvider: number;
  model: string;
  inputTokens: number;
  outputTokens: number;
  units: number;
  status: number;
  errorMessage: string | null;
  agency: {
    id: string;
    brandName: string;
  };
  createdBy: {
    id: string;
    firstName: string;
    lastName: string;
  };
}

@Component({
  name: 'AgenticTaskList',
  components: { Alert, AgenticTaskLogViewer }
})
export default class extends GiganautVue {

  private agenticTasks: AgenticTask[] = [];
  private loading = true;
  private search = '';

  $refs!: {
    logViewer: AgenticTaskLogViewer;
  };

  getStatusColor(status: number): string {
    switch (status) {
      case 90: return 'success'; // COMPLETED
      case 80: return 'error';   // FAILED
      case 10: return 'warning'; // PENDING
      default: return 'grey';
    }
  }

  get headers() {
    return [
      { text: 'Created', value: 'createdAt' },
      { text: 'Agency', value: 'agency.brandName' },
      { text: 'Created By', value: 'createdBy' },
      { text: 'Task Type', value: 'taskType' },
      { text: 'Task Category', value: 'taskCategory' },
      { text: 'Provider', value: 'modelProvider' },
      { text: 'Model', value: 'model' },
      { text: 'Input Tokens', value: 'inputTokens', align: 'end' },
      { text: 'Output Tokens', value: 'outputTokens', align: 'end' },
      { text: 'Total Tokens', value: 'totalTokens', align: 'end' },
      { text: 'Units', value: 'units', align: 'end' },
      { text: 'Status', value: 'status' },
      { text: 'Finished', value: 'finishedAt' },
      { text: '', value: 'actions', sortable: false, width: '50px' },
    ];
  }

  created() {
    this.getAgenticTasks();
  }

  async getAgenticTasks() {
    this.loading = true;
    try {
      const response = await ajax.get('/api/v1/sys/agentic-tasks');
      this.agenticTasks = response.data;
    } catch (error) {
      console.error('Failed to load agentic tasks:', error);
    } finally {
      this.loading = false;
    }
  }

  onRowClick(item: AgenticTask) {
    this.viewLog(item);
  }

  viewLog(item: AgenticTask) {
    if (item.agency && item.agency.id && item.id) {
      this.$refs.logViewer.open(item.agency.id, item.id);
    } else {
      console.warn('Cannot view log: missing agency ID or task ID');
    }
  }
}
